import { getSVGImageUrl } from 'lib/image/imageUtils'
import React from 'react'
import { useIntl } from 'react-intl'

function useWhyWorkForUsItems() {
  const intl = useIntl()

  return [
    {
      title: intl.formatMessage({
        id: 'CxEkctVkko',
        defaultMessage: 'Discounted Luxury Escapes Travel',
        description: 'Benefit title for discounted travel perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'Xx0VjGboKg',
        defaultMessage: 'Our team receive up to 20% off Luxury Escapes products.',
        description: 'Benefit description for discounted travel perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-bestpriceguarantee')}
        alt={intl.formatMessage({
          id: 'Qt9cCKG44V',
          defaultMessage: 'best price guarantee',
          description: 'Alt text for discounted travel benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'XZITB5mUu/',
        defaultMessage: 'Birthday Leave',
        description: 'Benefit title for birthday leave perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'ADmMlwjIX5',
        defaultMessage: 'Celebrate your special day by taking \u00BD a day off and receiving a $50 Luxury Escapes credit.',
        description: 'Benefit description for birthday leave perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-birthday')}
        alt={intl.formatMessage({
          id: 'OZS0y2N2TV',
          defaultMessage: 'birthday',
          description: 'Alt text for birthday leave benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '5UXrU7xRh3',
        defaultMessage: 'Fitness',
        description: 'Benefit title for fitness perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'CkKgvqd11e',
        defaultMessage: 'Gyms on site or corporate gym memberships options available at discounted rates.',
        description: 'Benefit description for fitness perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-fitness')}
        alt={intl.formatMessage({
          id: 'Yz/vUY2qh9',
          defaultMessage: 'fitness',
          description: 'Alt text for fitness benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'nOcsrwsAEK',
        defaultMessage: 'Health & Wellbeing Program',
        description: 'Benefit title for health and wellbeing program on careers page',
      }),
      text: intl.formatMessage({
        id: 'K/ZhJYC980',
        defaultMessage: 'Annual flu shots, lunch and learn sessions with health professionals, access to the LE employee assistance program.',
        description: 'Benefit description for health and wellbeing program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-wellbeing')}
        alt={intl.formatMessage({
          id: 'zAZlabZxBP',
          defaultMessage: 'wellbeing',
          description: 'Alt text for health and wellbeing benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'EMYy7wUZhZ',
        defaultMessage: 'Baby Bonus and Partner Leave',
        description: 'Benefit title for parental leave perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'ZYJos1Cnfj',
        defaultMessage: 'Having a Bub? Enjoy 8 weeks bonus pay as primary carer!',
        description: 'Benefit description for parental leave perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-dad_partner_pay')}
        alt={intl.formatMessage({
          id: '3o66VvKtL0',
          defaultMessage: 'dad partner pay',
          description: 'Alt text for parental leave benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'meXEgjUogf',
        defaultMessage: 'Break to Donate',
        description: 'Benefit title for blood donation leave on careers page',
      }),
      text: intl.formatMessage({
        id: '1+JJqJT5RC',
        defaultMessage: 'Feel like donating blood? Take paid time off to do so!',
        description: 'Benefit description for blood donation leave on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-blood')}
        alt={intl.formatMessage({
          id: 'CSzPPN9VPy',
          defaultMessage: 'blood',
          description: 'Alt text for blood donation leave benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '2T1L54yzOd',
        defaultMessage: 'Flexibility',
        description: 'Benefit title for flexible work environment on careers page',
      }),
      text: intl.formatMessage({
        id: 'oM3fR27fBG',
        defaultMessage: 'Fun, dynamic and flexible work environment.',
        description: 'Benefit description for flexible work environment on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-flexibility')}
        alt={intl.formatMessage({
          id: 'mBqyEBv5Cm',
          defaultMessage: 'flexibility',
          description: 'Alt text for flexible work benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'FeDpwF0SDQ',
        defaultMessage: 'Regular Networking Events',
        description: 'Benefit title for networking events on careers page',
      }),
      text: intl.formatMessage({
        id: '+9B1oFvG4x',
        defaultMessage: 'Celebration and recognition prizes, ping pong onsite, wine tastings and much more!',
        description: 'Benefit description for networking events on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-team_building')}
        alt={intl.formatMessage({
          id: 'So7v1nqFOs',
          defaultMessage: 'team building',
          description: 'Alt text for networking events benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'mnxf8A6rKE',
        defaultMessage: 'Learning & Development',
        description: 'Benefit title for learning and development on careers page',
      }),
      text: intl.formatMessage({
        id: '+6kDXrBvp9',
        defaultMessage: 'Build your career with Leadership Programs sponsored by our CEO, eLearning courses and onsite workshops.',
        description: 'Benefit description for learning and development on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-learning')}
        alt={intl.formatMessage({
          id: '2DdFfHnfyv',
          defaultMessage: 'learning',
          description: 'Alt text for learning and development benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'li3BhAu05P',
        defaultMessage: 'Refer a Friend',
        description: 'Benefit title for employee referral program on careers page',
      }),
      text: intl.formatMessage({
        id: 'ygi3xstazG',
        defaultMessage: 'Know someone who has what it takes to join the LE team? Enjoy a $2500 referral reward for successfully referring someone to LE!',
        description: 'Benefit description for employee referral program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-referral')}
        alt={intl.formatMessage({
          id: 'x51oVJV3jU',
          defaultMessage: 'referral',
          description: 'Alt text for employee referral benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'YsarEE9EFr',
        defaultMessage: 'Breakfast and Lunches',
        description: 'Benefit title for free meals perk on careers page',
      }),
      text: intl.formatMessage({
        id: '0J8LXXIDz9',
        defaultMessage: 'Breakfast and lunches supplied, along with fresh fruit and coffee.',
        description: 'Benefit description for free meals perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-breakfast')}
        alt={intl.formatMessage({
          id: 'nEgwx/Siz4',
          defaultMessage: 'breakfast',
          description: 'Alt text for free meals benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'cI4G5ll/SQ',
        defaultMessage: 'Culture First',
        description: 'Benefit title for inclusive culture on careers page',
      }),
      text: intl.formatMessage({
        id: '1eGR4IxnrC',
        defaultMessage: 'We look to add to our culture with every hire \u2013 you don’t need to conform to succeed here.',
        description: 'Benefit description for inclusive culture on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-culture')}
        alt={intl.formatMessage({
          id: 'leYyC29DIx',
          defaultMessage: 'culture',
          description: 'Alt text for inclusive culture benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'waz0smFCKq',
        defaultMessage: 'Seamless Communication',
        description: 'Benefit title for communication practices on careers page',
      }),
      text: intl.formatMessage({
        id: 'oB4zIFvBdw',
        defaultMessage: 'Stay in the loop with fortnightly newsletter updates and regular team meetings on both a global and local scale.',
        description: 'Benefit description for communication practices on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-communication')}
        alt={intl.formatMessage({
          id: 'PJlmmkO6fX',
          defaultMessage: 'communication',
          description: 'Alt text for seamless communication benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'jXrPYjdWdb',
        defaultMessage: 'Purchase Annual Leave Program',
        description: 'Benefit title for purchase leave program on careers page',
      }),
      text: intl.formatMessage({
        id: '+Yj04KoEkJ',
        defaultMessage: 'Fancy some extra time off each year? We offer a purchase leave program of up to an additional 4 weeks per year.',
        description: 'Benefit description for purchase leave program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_calendar')}
        alt={intl.formatMessage({
          id: 'M8Ljs1IDCa',
          defaultMessage: 'calendar',
          description: 'Alt text for purchase leave program benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'at6nVDuyaH',
        defaultMessage: 'Novated Lease Program',
        description: 'Benefit title for novated lease program on careers page',
      }),
      text: intl.formatMessage({
        id: '+Bk5LjoW7j',
        defaultMessage: 'Looking for a new set of wheels? Purchase a new or used car through our motor vehicle novated leasing program.',
        description: 'Benefit description for novated lease program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_car')}
        alt={intl.formatMessage({
          id: 'bv4HE5L/qw',
          defaultMessage: 'car',
          description: 'Alt text for novated lease program benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '1hOsjlYbzt',
        defaultMessage: 'Familiarisation Trips',
        description: 'Benefit title for familiarisation trips on careers page',
      }),
      text: intl.formatMessage({
        id: 'v7neL+MHyO',
        defaultMessage: 'Immerse yourself in the same luxurious travel experiences that our customers enjoy.',
        description: 'Benefit description for familiarisation trips on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_map')}
        alt={intl.formatMessage({
          id: '3p0shgfYs1',
          defaultMessage: 'map',
          description: 'Alt text for familiarisation trips benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'no95XbDTRN',
        defaultMessage: 'Holiday and Experience Giveaways',
        description: 'Benefit title for holiday giveaways on careers page',
      }),
      text: intl.formatMessage({
        id: '7fek9cS+g7',
        defaultMessage: 'Luxury Escapes is super generous with our team with regular giveaways of credit to our team members and holidays at our Xmas celebrations!',
        description: 'Benefit description for holiday giveaways on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_tickets')}
        alt={intl.formatMessage({
          id: 'LpdDox+z80',
          defaultMessage: 'tickets',
          description: 'Alt text for holiday giveaways benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '2VYuF7tHsx',
        defaultMessage: 'Hallmark Day Celebrations',
        description: 'Benefit title for hallmark day celebrations on careers page',
      }),
      text: intl.formatMessage({
        id: 'xLTw3AFGZ/',
        defaultMessage: 'At Luxury Escapes we like to celebrate the extraordinary and the ordinary, join in for international cuisine days, donut day and more.',
        description: 'Benefit description for hallmark day celebrations on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_celebrate')}
        alt={intl.formatMessage({
          id: 'D+awjTVzJF',
          defaultMessage: 'celebrate',
          description: 'Alt text for hallmark day celebrations benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'cJirdS2uve',
        defaultMessage: 'Loyalty Reward',
        description: 'Benefit title for loyalty reward on careers page',
      }),
      text: intl.formatMessage({
        id: 'XEYgCFa1UX',
        defaultMessage: 'On your yearly anniversary of service with Luxury Escapes, we will gift you either a credit or a discount code to use on a fabulous Luxury Escapes holiday!',
        description: 'Benefit description for loyalty reward on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-loyalty-reward')}
        alt={intl.formatMessage({
          id: 'TT93NPni6C',
          defaultMessage: 'wellbeing',
          description: 'Alt text for loyalty reward benefit icon on careers page',
        })}
        height="68"
      />,
    },
  ]
}

export default useWhyWorkForUsItems
